import {APIClient} from '../backend/ApiClient';

export const useGetPreview = () => {
    const apiClient = APIClient();

    return (fileId: string) => {
        return apiClient.getPreviewUrl(fileId).then((data) => data.token);
    };
};